import { environment } from '../../../environments/environment';

/**
 * @description Builds a URL for the Exploris Health marketing website
 * @param path - The path/hash to append (e.g., '/product', '/product')
 * @returns The complete absolute URL
 *
 * @remarks
 * The site is currently English-only, so no language prefix is emitted. The
 * previous `/de` prefix pointed at routes that do not exist on the new site
 * and 404'd for German users. Reintroduce a prefix here once the marketing
 * site ships German routes.
 *
 * @example
 * getExplorisHealthUrl('/product') // returns 'https://www.explorishealth.com/product'
 * getExplorisHealthUrl('/product')  // returns 'https://www.explorishealth.com/product'
 */
export function getExplorisHealthUrl(path = ''): string {
  return `${environment.explorisHealthBaseUrl}${path}`;
}
